/* ------------------------------------------------------------------------------
@name: BASE_URL
@description: BASE_URL
--------------------------------------------------------------------------------- */

const URL_BASE_WEB = "https://test-warehouse.thaistore.id/";

export const BASE_URL = URL_BASE_WEB;
